import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { removeItem } from "../../../redux/slices/CartSlice";
import GradientButton from "../../Buttons/GradientButton/GradientButton";
import NftInteractionModal from "../NftInteractionModal/NftInteractionModal";
import StyledMdText from "../../../common/components/styledMdText/StyledMdText";
import StyledLgText from "../../../common/components/styledLgText/StyledLgText";
import StyledCtaText from "../../../common/components/styledCtaText/StyledCtaText";
import StyledH4Heading from "../../../common/components/styledH4Heading/StyledH4Heading";
import StyledH6Heading from "../../../common/components/styledH6Heading/StyledH6Heading";
import { useCartNfts } from "../../../Hooks/api/useCartNfts";
import { useAccount } from "wagmi";
import { useGetCartNft } from "../../../Hooks/api/useGetCartList";
import { useClearAllNfts } from "../../../Hooks/api/useClearAllNfts";
import InsufficientFundsModal from "../InsufficientFundsModal/InsufficientFundsModal";
import useBuyBulkNfts from "../../../Hooks/api/useBuyBulkNfts";
import Spinner from "../../Loader/spinner";
import { getGasPrice } from "../../../context/MintingContract";

const NftCartHub = ({ closeModal }) => {
  const [showInsufficientFunds, setInsufficientFundsModal] = useState(false);
  const dispatch = useDispatch();
  const { address: walletAddress } = useAccount();
  const { mutate: handleCartNft,isPending } = useCartNfts();
  const { mutate: clearAllNfts ,isPending : isPendingClearAll} = useClearAllNfts();
  const { data: cartData  } = useGetCartNft(walletAddress);
  const { walletBalance } = useSelector((state) => state.user);
  const { buyBulkItems, loading } = useBuyBulkNfts();
  const [remainingTime, setRemainingTime] = useState(0);

  const handleRemoveItem = (item) => {
    if (!walletAddress) {
      console.error("Wallet address is not connected or invalid");
      return;
    }
    dispatch(removeItem(item));

    handleCartNft({
      nftId: item.nft_id,
      walletAddress,
      action: "remove",
      contract_address: process.env.REACT_APP_CONTRACT_ADDRESS,
    });
  };
  useEffect(() => {
    const updateRemainingTime = () => {
      const storedTime = localStorage.getItem("cartTimestamp");

      if (storedTime) {
        const storedTimestamp = parseInt(storedTime, 10);
        const currentTime = Date.now();
        const timeLeft = storedTimestamp - currentTime;
        setRemainingTime(Math.max(0, timeLeft));
      } else {
        setRemainingTime(0);
      }
    };

    updateRemainingTime();
    const interval = setInterval(updateRemainingTime, 1000);

    return () => clearInterval(interval);
  }, []);

  const handleClearCart = () => {
    clearAllNfts({ wallet_address: walletAddress });
  };

  const totalPrice =
    cartData?.reduce((total, item) => total + parseFloat(item.price || 0), 0) ||
    0;

  const handleButtonClick = async () => {
  
    const gasPrice = await getGasPrice(); 
    if (walletBalance > totalPrice) {
      const nftIds = cartData?.map((item) => item.nft_id) || [];
      await buyBulkItems(
        nftIds,
        totalPrice,
        gasPrice,
        () => {
          closeModal();
          handleClearCart();
        },
      );
    } else {
      setInsufficientFundsModal(true);
    }
  
   }
  
 
  const [showLoader, setShowLoader] = useState(isPending);

  
    useEffect(() => {
      if (isPending||isPendingClearAll) {
        setShowLoader(true);
      } else {
        const timeout = setTimeout(() => {
          setShowLoader(false);
        }, 1200);
        return () => clearTimeout(timeout); 
      }
    }, [isPending,isPendingClearAll]);

  


  return (
    <>
      <NftInteractionModal
        width={
          "w-full sm:w-[70%] md:w-[50%] lg:w-[40%] xl:w-[30%] h-[100%] !fixed !top-0 !right-0 !rounded-none !border-0 "
        }
        handleClose={closeModal}
        content={
          <div className="w-full p-7 flex flex-col gap-6 ">
            <div className="space-y-3">
              <div>
                <StyledH4Heading>My Cart</StyledH4Heading>
              </div>
              <hr className="h-[1px] w-full bg-white" />
            {cartData?.length === 0 ? null
            :  
            showLoader? null :  <div className="bg-[#252525] hover:bg-opacity-60 border rounded-md py-[15px] px-[20px] mt-5 border-bright-yellow flex justify-between">
                <StyledMdText>Confirm within:</StyledMdText>

                <StyledMdText >
                  {Math.floor(remainingTime / 60000)}m{" "}
                  {Math.floor((remainingTime % 60000) / 1000)}sec
                </StyledMdText>
              </div>}
            </div>
            {cartData?.length === 0 ? (
              <div className="flex flex-col items-center justify-center h-full">
                <StyledLgText fontColor={"text-bright-yellow"}>
                  No Items in the Cart
                </StyledLgText>
              </div>
            ) : (
              <>
              <div className="flex flex-col gap-6 overflow-y-auto no-scrollbar h-full pb-3">
              {showLoader ?
              
             <div className="flex flex-col justify-center items-center h-full">
               <Spinner />
             </div>
               : 
               <>
                <div className="flex justify-between items-center">
                    <StyledH6Heading>
                      Total Items: {cartData?.length}
                    </StyledH6Heading>

                    <button
                      onClick={handleClearCart}
                      className="bg-[#252525] hover:bg-opacity-60 border rounded-md py-1.5 px-5 disabled:cursor-not-allowed"
                      disabled={isPendingClearAll}
                    >
                      Clear all
                    </button>
                  </div>
                  {cartData?.map((item, index) => (
                    <div
                      key={index}
                      className="w-full flex justify-between gap-4 lg:gap-8"
                    >
                      <div className="w-full flex justify-center items-end gap-4">
                        <div className="min-w-20 md:min-w-20 lg:min-w-24 rounded-xl overflow-hidden">
                          <img
                            className="max-h-24"
                            src={item.image}
                            alt="NFTs"
                          />
                        </div>
                        <div className="w-full">
                          <StyledMdText>{item.tier}</StyledMdText>
                          <StyledH6Heading>{item.name}</StyledH6Heading>
                        </div>
                      </div>
                      <div className="flex flex-col justify-end self-stretch text-right gap-2">
                        <StyledLgText fontColor="font-bold">
                          {item.price} ETH
                        </StyledLgText>
                        <button
                          onClick={() => handleRemoveItem(item)}
                          className="bg-[#252525] hover:bg-opacity-60 border rounded-md py-1.5 px-5"
                          disabled={isPending}
                        >
                         Remove
                        </button>
                      </div>
                    </div>
                  ))}</>
                  }
                </div>
                <hr className="h-[1px] w-full bg-white" />
              </>
            )}
            <div>
              {cartData?.length > 0 && (
                <div className="bg-[#252525] p-5 flex flex-col gap-2 rounded-xl">
                  <div className="flex justify-between">
                    <StyledCtaText>Total</StyledCtaText>
                    <StyledH6Heading>{totalPrice.toFixed(3)} ETH</StyledH6Heading>
                  </div>
                  <hr className="h-[0.5px] w-full bg-white opacity-40" />
                  <div className="flex justify-between">
                    <StyledCtaText>Grand Total</StyledCtaText>
                    <StyledH6Heading>{totalPrice.toFixed(3)} ETH</StyledH6Heading>
                  </div>
                </div>
              )}
              <div
                className={
                  loading
                    ? `animate-pulse mt-4`
                    : cartData?.length === 0
                    ? "w-full h-full flex items-end"
                    : "w-full mt-4"
                }
              >
                <GradientButton
                  fontColor={"w-full"}
                  children={loading ? <Spinner /> : "Complete Purchase"}
                  disabled={cartData?.length === 0 || loading}
                  onClick={handleButtonClick}
                />
              </div>
            </div>
          </div>
        }
      />
      {showInsufficientFunds && (
        <InsufficientFundsModal
          nft={totalPrice}
          closeModal={() => setInsufficientFundsModal(false)}
        />
      )}
    </>
  );
};

export default NftCartHub;
